import { IntegrationsSection } from "@/components/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/integrations")({
  component: IntegrationsSection,
});
